function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Collapse from "../../../../eden-collapse";

const Details = _ref => {
  let {
    open,
    children,
    onToggle,
    ...props
  } = _ref;
  const detailsRef = useRef(null);
  const [expand, setExpand] = useState(props.open);
  const [internalOpen, setInternalOpen] = useState(props.open);
  const childrenArray = React.Children.toArray(children);
  const summary = childrenArray.shift();
  useEffect(() => {
    const cleanUp = internalOnToggle({}, open);
    return () => {
      cleanUp();
    };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setExpand(internalOpen);
  }, [internalOpen]);

  const internalOnToggle = (event, nextOpen) => {
    let timeout;

    if (nextOpen) {
      timeout = setTimeout(() => {
        setInternalOpen(true);
      });
    } else {
      if (expand) {
        var _event$preventDefault;

        (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 ? void 0 : _event$preventDefault.call(event);
        setExpand(false);
      } else {
        timeout = setTimeout(() => {
          setInternalOpen(false);
        });
      }
    } // Return a clean up function


    return () => clearTimeout(timeout);
  };

  return /*#__PURE__*/React.createElement("details", _extends({
    ref: detailsRef,
    open: internalOpen,
    onToggle: event => {
      event.stopPropagation();
      onToggle === null || onToggle === void 0 ? void 0 : onToggle(event);
    }
  }, props), summary.props.onClick ? summary : /*#__PURE__*/React.cloneElement(summary, {
    onClick: event => {
      internalOnToggle(event, !internalOpen);
    }
  }), /*#__PURE__*/React.createElement(Collapse, {
    expand: expand,
    minHeight: "0px",
    onAnimationEnd: () => {
      if (!expand) {
        detailsRef.current.querySelector("summary").click();
      }
    }
  }, childrenArray));
};

Details.propTypes = {
  /** Contents rendered inside the details. First child must be a `<Summary>` element. */
  children: PropTypes.node.isRequired,

  /** Whether details is open */
  open: PropTypes.bool,

  /** Handler called after a toggle occurs. Use `event.target.open` to get the current `open` state of the `Details`.*/
  onToggle: PropTypes.func
};
export default Details;